<template>
  <el-form inline :model="selectModel" label-position="right">
    <el-form-item label="卡ID">
      <el-input v-model="selectModel.cardId" />
    </el-form-item>
    <el-form-item label="类型">
      <el-select v-model="selectModel.type" placeholder="请选择" clearable>
        <el-option v-for="(a,b) in $store.state.payType" :key="b" :value="b" :label="a" />
      </el-select>
    </el-form-item>
    <el-form-item label="状态">
      <el-select v-model="selectModel.status" placeholder="请选择" clearable>
        <el-option v-for="(a,b) in $store.state.payStatus" :key="b" :value="b" :label="a" />
      </el-select>
    </el-form-item>
    <el-form-item label="支付方式">
      <el-select v-model="selectModel.method" placeholder="请选择" clearable>
        <el-option v-for="(a,b) in $store.state.payMethod" :key="b" :value="b" :label="a" />
      </el-select>
    </el-form-item>
    <el-form-item class="main-form-item-float-right">
      <el-button-group>
        <el-button type="primary" icon="el-icon-search" @click="queryTableData">查询</el-button>
      </el-button-group>
    </el-form-item>
  </el-form>

  <el-table
    :data="tableData"
    border
    stripe
    :default-sort="defaultSort"
    @sort-change="sort"
    style="width: 100%;">
    <el-table-column label="ID" prop="id" width="100px" align="center" sortable="custom" />
    <el-table-column label="创建时间" prop="createTime" min-width="180px" />
    <el-table-column label="订单名" prop="name" min-width="100px" />
    <el-table-column label="卡ID" prop="cardId" min-width="100px" />
    <el-table-column label="类型" prop="typeDes" min-width="100px" />
    <el-table-column label="状态" prop="statusDes" min-width="100px" />
    <el-table-column label="支付方式" prop="methodDes" min-width="100px" />
    <el-table-column label="金额" prop="amount" min-width="100px" />
  </el-table>
  <div style="margin-top: 10px; text-align: right;">
    <el-pagination
      layout="prev, pager, next,jumper"
      :total="total"
      @current-change="applyCurrentPage" />
  </div>

  <el-dialog custom-class="main-el-dialog" :title="dialog.title" v-model="dialog.visibled" width="600px">
    <el-form :model="dialog.form" ref="dialogForm" label-width="80px">
      <el-form-item
        label="名称" prop="name"
        :rules="[
          { required: true, message: '名称不能为空', trigger: 'blur'}
        ]">
        <el-input v-model="dialog.form.name" :readonly="dialog.readonly" />
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialog.visibled = false">取消</el-button>
        <el-button v-if="!dialog.readonly" type="primary" @click="dialog.submit">确定</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import { handleCatchStatus } from '../../api/handler';

export default {
  data() {
    return {
      selectModel: {},
      selectSort: null,
      defaultSort: {prop: 'id', order: 'descending'},
      tableData: [],
      total: 0,
      current: 1,
      dialog: {
        visibled: false,
        created: false,
        readonly: false,
        title: '',
        form: {},
        submit: () => true
      },
      roles: []
    };
  },
  created() {
    this.applySortSelect(this.defaultSort);
    this.queryTableData();
  },
  mounted() {
  },
  methods: {
    queryTableData() {
      this.selectModel.sort = this.selectSort;
      this.selectModel.page = this.current - 1;
      this.$api.getPayOrderPage(this.selectModel)
        .then(data => {
          this.tableData = data.content;
          this.total = data.totalElements;
        })
        .catch(handleCatchStatus);
    },
    sort({ prop, order }) {
      this.applySortSelect({ prop, order });
      this.queryTableData();
    },
    applySortSelect({ prop, order }) {
      if (order) {
        this.selectSort = `${prop},${order === 'ascending' ? 'ASC' : 'DESC'}`;
        return;
      }
      this.selectSort = null;
    },
    applyCurrentPage(current) {
      this.current = current;
      this.queryTableData();
    },
    showDialogForm({data, created = false, readonly = false}) {
      this.dialog.readonly = readonly;
      this.dialog.created = created;
      this.dialog.visibled = true;
      if (data) {
        this.dialog.form = { ...data };
      }

      let submit;
      if (created) {
        this.dialog.title = '创建';
        this.dialog.form = {};
        submit = () => this.$api.createCollege(this.dialog.form);
      } else {
        this.dialog.title = '修改';
        submit = () => this.$api.updateCollege(this.dialog.form);
      }

      if (readonly) {
        this.dialog.title = '详情';
        submit = () => false;
      }

      this.dialog.submit = () => this.validateForm(() => submit()
        .then(() => {
          this.$message.success('操作成功');
          this.dialog.visibled = false;
          this.queryTableData();
        })
        .catch(handleCatchStatus));
    },
    validateForm(successFn) {
      this.$refs.dialogForm.validate(valid => {
        if (valid) {
          successFn();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.dialogForm.resetFields();
    },
    deleteAciton(data) {
      this.$confirm('此操作将永久删除该内容, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => this.$api.deleteCollege(data.id))
        .then(() => {
          this.$message.success('删除成功!');
          this.queryTableData();
        })
        .catch(() => this.$message.info('已取消删除'));
    }
  }
};
</script>
